module.exports = __webpack_public_path__ + "static/img/dgm01.f253baf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/personRain/dgm01.png
// module id = 56wc
// module chunks = 2